import { Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const FooterWrapper = styled.div`
  ${Media.Mobile`
    margin-bottom: ${Spacing.XxLarge}px;
  `}
`

export const ChildrenWrapper = styled.div`
  /* Used for preventing background shifting when a modal is used */
  width: 100vw; 
`